// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
import { primaryButton, secundaryButton, transitionalButton, } from '../../global.style';
/*
 * 'fixed', não 'absolute': o drawer é montado dentro do
 * '#root-app_side_content', que tem 'position: relative' (o loading da troca
 * de tela se ancora nele) e começa abaixo do cabeçalho. Com 'absolute' o
 * painel de 100vh descia junto e o rodapé — com o botão de confirmar (ex.:
 * Trocar, no drawer de tenant) — ficava cortado fora da tela pelo
 * 'overflow: hidden' do body.
 */
export const DrawerContainer = styled.div `
  top: 0;
  left: 0;
  z-index: 1110;
  width: 100vw;
  height: 100vh;
  position: fixed;

  .root-app_drawer_overlay {
    z-index: 1;
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: var(--color-contrast-black);
  }

  .root-app_drawer {
    right: 0;
    z-index: 2;
    height: 100vh;
    max-width: 685px;
    overflow: hidden;
    position: absolute;
    background-color: var(--color-contrast-white);

    display: flex;
    flex-direction: column;

    & > * {
      display: flex;
    }

    & p {
      color: var(--color-neutral-500);
    }

    .root-app_drawer-title_container {
      padding: 24px;
      align-items: center;
      justify-content: space-between;

      p.root-app_drawer-title_text {
        margin: 0;
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-semibold);
      }

      p.root-app_drawer-description_text {
        margin: 0;
        font-size: var(--font-size-sm);
        margin-top: var(--spacing-size-3xs);
      }

      button.root-app_drawer-title_close_btn {
        ${secundaryButton}

        padding: 0;
        border: none;
        border-radius: var(--border-radius-sm);

        img {
          width: 24px;
          height: 24px;
        }
      }
    }

    .root-app_drawer-body_container {
      flex-grow: 1;
      background-color: var(--color-neutral-background);

      /**
       * O drawer é 100vh com header e footer de altura fixa, então o corpo é
       * quem precisa ceder quando o conteúdo passa da tela.
       *
       * O 'min-height: 0' não é decorativo: sem ele o flex item mantém o
       * 'min-height: auto' padrão, se recusa a encolher abaixo do conteúdo e o
       * excesso é decepado pelo 'overflow: hidden' do '.root-app_drawer' — sem
       * barra de rolagem e sem como alcançar o final da lista.
       */
      min-height: 0;
      overflow-y: auto;
      overscroll-behavior: contain;
    }

    /*
     * Sem a faixa de titulo o corpo encosta no topo do painel, entao o fundo
     * neutro que separava as faixas deixa de fazer sentido. O overflow sai do
     * corpo porque quem rola passa a ser o proprio conteudo.
     */
    &.root-app_drawer--no-header .root-app_drawer-body_container {
      background-color: transparent;
      overflow: hidden;
    }

    /*
     * Rodape apertado, para drawers cujo corpo e uma aplicacao inteira: o
     * respiro do rodape padrao come altura util do conteudo.
     */
    &.root-app_drawer--compact-footer .root-app_drawer-footer_container {
      padding: 4px;

      button {
        font-size: 13px;
      }
    }

    .root-app_drawer-footer_container {
      gap: 16px;
      padding: 24px 32px;
      justify-content: flex-end;
      background-color: var(--color-neutral-background);

      button {
        ${transitionalButton}
        padding: 12px 24px;
        font-size: var(--font-size-default);
        font-weight: var(--font-weight-semibold);
      }

      button.root-app_drawer-footer-btn_cancel {
        ${secundaryButton}

        /*
         * Largura publicada pelo conteudo, quando ele quiser alinhar o botao a
         * algo proprio. O drawer do chat espelha aqui o botao de enviar
         * pergunta, medido dentro do iframe. Sem a variavel, largura
         * automatica — que e o comportamento dos demais drawers.
         */
        width: var(--root-app-chat-close-width, auto);
      }

      button.root-app_drawer-footer-btn_confirm {
        ${primaryButton}
      }
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  &.open {
    animation: fadeIn 0.2s;
    display: block;
    .root-app_drawer_overlay {
      opacity: var(--opacity-level-1);
    }
    .root-app_drawer {
      width: 100vw;
    }
  }

  &.closed {
    display: none;
    .root-app_drawer_overlay {
      opacity: 0;
    }
    .root-app_drawer {
      width: 0vw;
    }
  }
`;
//# sourceMappingURL=style.js.map